import config from 'app-config'


const isDevelopment = config.env === 'development'

let request = {}

if (process.env.WEBPACK === 'build.client' || process.env.WEBPACK === 'site.dev') {
  request = require('axios')

  // request = {
  //   get: (url) => axios.request({
  //     url,
  //     method: 'get',
  //     headers:{
  //       Accept: 'application/json',
  //       'Content-Type': 'application/json',
  //       // Cookie: document.cookie,
  //     },
  //     withCredentials: true,
  //   }),
  //   post: (url) => axios.request({
  //     url,
  //     method: 'post',
  //     headers:{
  //       Accept: 'application/json',
  //       'Content-Type': 'application/json',
  //       // Cookie: document.cookie,
  //     },
  //     withCredentials: true,
  //   }),
  // }

  request.interceptors.request.use(
    (config) => {
      if (!config.headers) {
        config.headers = {}
      }

      if (isDevelopment) {
        config.url = config.url.replace(/.*smartsarov.ru/, '/proxy')
      }

      config.headers.Accept = 'application/json'
      // config.withCredentials  = true

      return config
    },
    (error) => Promise.reject(error)
  )
}


export default request
